import Vue from 'vue';
import Component from 'vue-class-component';
import dayjs from 'dayjs';
import { sendItemToAnalytics } from 'common/utils/sendAnalyticsEvent';
import HeartIt from 'common/components/HeartIt';
import Rating from 'common/components/Rating';
import SocialShare from 'components/SocialShare';
import ReviewsBar from 'components/ReviewsBar';
import PurchaseDetailButton from 'components/PurchaseDetailButton';
import ProductShippingSelector from 'components/ProductShippingSelector';
import NewCarousel from 'components/NewCarousel';
import HasGiftButton from 'components/HasGiftButton';
import CartLimit from 'assets/graphql/queries/CartLimit.graphql';
import CartQuery from 'assets/graphql/queries/Cart.graphql';
import DeliveryInfoQuery from 'assets/graphql/queries/DeliveryInfo.graphql';
import getLastTld from 'common/services/utils/getLastTld';
import getParticipantsIcon from 'common/services/utils/getParticipantsIcon';
import googleAnalyticsEvent from 'common/services/googleAnalytics';
import currency from 'common/filters/currency';
import getBoxPrice from 'services/getBoxPrice';
import useAccount from 'composables/useAccount';
import useShoppingCartCleanUp from 'composables/useShoppingCartCleanUp';
import { addToCartService } from 'common/services/utils/addToCart';

Vue.filter('currency', currency);

@Component({
  apollo: {
    cart: {
      query: CartQuery,
    },
    deliveryInfo: {
      query: DeliveryInfoQuery,
      update(data) {
        return { ...data };
      },
    },
    cart_limit: {
      query: CartLimit,
    },
  },
  components: {
    HeartIt,
    Rating,
    SocialShare,
    ReviewsBar,
    PurchaseDetailButton,
    ProductShippingSelector,
    NewCarousel,
    HasGiftButton,
  },
  props: [
    'box',
    'boxActivitiesLength',
    'saleButtonText',
    'isBoxFriendDay',
    'userLoggedIn',
    'gift',
    'availableBox',
    'customBox',
  ],
  methods: {
    getBoxPrice,
  },

  setup() {
    const { getUserData } = useAccount();
    const { shoppingCartCleanUp } = useShoppingCartCleanUp();
    return {
      getUserData,
      shoppingCartCleanUp,
    };
  },
})
export default class BoxInformationComponent extends Vue {
  showShippingModal = false;
  loading = false;
  buttonTouched = '';
  showError = false;
  shipping = {
    type: 'digital',
    icon: 'Email2.svg',
    iconClass: 'Email2-icon',
    description: 'Envío digital por e-mail',
    isFree: true,
    isNew: false,
  };
  goToCheckout = true;
  hotelesExpress = this.customBox === 'HotelesExpress';

  mounted() {
    this.selectedOption = this.shippingFormats?.options?.[0]?.available ? 0 : 1;
    // Google Optimize event triggering.
    // eslint-disable-next-line no-undef, quote-props
    this.shipping = {
      type: this.cartItems.length ? 'digital' : 'social',
      icon: this.cartItems.length ? 'Email2.svg' : 'WhatsApp.svg',
      iconClass: this.cartItems.length ? 'Email2-icon' : 'WhatsApp-icon',
      description: this.cartItems.length
        ? 'Envío digital por e-mail'
        : 'Envío por whatsapp',
      isFree: true,
      isNew: false,
    };
  }

  get boxUrl() {
    return `https://bigbox.com.${getLastTld()}${this.box.product_url}`;
  }

  get cartItems() {
    return this.cart ? this.cart.items : [];
  }

  get country() {
    return getLastTld();
  }

  get isCartFull() {
    if (this.cart) {
      return this.cart.items.length >= this.cart_limit;
    }
    return false;
  }

  get priceInUsd() {
    if (this.box.price_in_usd && this.box.use_price_in_usd) {
      return this.box.price_in_usd;
    }
    return -1;
  }

  get formattedDate() {
    return dayjs(this.box.dynamic_expiration_date).format('DD/MM/YYYY');
  }

  get participantsIcon() {
    // Added RegEx here to extract the number from the string of box.participants
    return this.box.participants
      ? getParticipantsIcon(this.box.participants.match(/\d+/g))
      : '';
  }

  get defaultImageThumbnail() {
    return this.box.physical_images || this.box.digital_images;
  }
  get hasMultipleImages() {
    return this.defaultImageThumbnail.length > 1;
  }
  get email() {
    return this.getUserData?.email || '';
  }

  async addToCart(box) {
    if (!this.availableBox) return;
    this.loading = !this.loading;
    const data = {
      boxId: box.id ? box.id.toString() : '',
      activityId: '',
      quantity: 1,
      isGroup: false,
      source: '',
      boxType: this.shipping.type,
      sellingSpotId: this.shipping.selling_spot_id
        ? this.shipping.selling_spot_id.toString()
        : '',
      kindId: this.shipping.kind_id ? this.shipping.kind_id.toString() : '',
      campaignSlug: this.$route.query.campaignSlug,
      landingSlug: this.$route.query.landingSlug,
    };

    await this.shoppingCartCleanUp(this.cart, data);
    const response = await addToCartService(data, this.$apollo);

    if (response.ok) {
      sendItemToAnalytics('add_to_cart', [box], undefined, {
        userData: {
          email: this.email,
        },
      });
      googleAnalyticsEvent('Compra', 'click', 'click_CTAcompra_boxview');
      this.loading = !this.loading;
      if (this.goToCheckout) {
        window.location = `https://${
          window.location.host + response.redirect_url
        }`;
      } else {
        this.$apollo.queries.cart.refetch();
        this.$emit('showCart');
      }
    } else {
      this.loading = !this.loading;
      this.showError = !this.showError;
    }
  }
}
